// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14 8.75 L14 3.25 C14 2.56 13.44 2 12.75 2 L10.75 2 C10.06 2 9.5 2.56 9.5 3.25 L9.5 8.75 C9.5 9.44 10.06 10 10.75 10 L12.75 10 C13.44 10 14 9.44 14 8.75 Z',
  'M6.5 8.75 L6.5 3.25 C6.5 2.56 5.94 2 5.25 2 L3.25 2 C2.56 2 2 2.56 2 3.25 L2 8.75 C2 9.44 2.56 10 3.25 10 L5.25 10 C5.94 10 6.5 9.44 6.5 8.75 Z',
  'M10 14.5 L8 12.5 L6 14.5',
];
